import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';
import { PageBuilderNumericTextboxModel } from '../page-builder-numeric-textbox.model';

@Component({
    selector: 'abw-page-builder-numeric-textbox-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => PageBuilderNumericTextboxFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => PageBuilderNumericTextboxFormComponent),
        multi: true
      }
    ],
    templateUrl: './page-builder-numeric-textbox-form.component.html',
    styleUrls: ['./page-builder-numeric-textbox-form.component.scss']
})
export class PageBuilderNumericTextboxFormComponent implements ControlValueAccessor {
    @Input() model: PageBuilderNumericTextboxModel;
    @Input() value: number;

    propagateChange = (_: any) => {};
    registerOnChange(fn) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: number) {
        this.value = value; 
    }

	validate({ value }: FormControl) {
		const isValid = (this.model as any).required && !value;
		return isValid && {
		  	invalid: true
		};
	}

  onInputChanged(event: any) {
    const value = event.target.value;
    const numericValue: number = !!value ? parseFloat(value.toString().replace(/\s/g, "").replace(",", ".")) : 0;
    this.value = numericValue;
    this.propagateChange(numericValue);
  }
}